<script>
import BaseInput from '@/components/lavender/Input/BaseInput.vue'
import LoginFormItemSelectCountry from '@/views/login/components/LoginFormItemSelectCountry.vue'

export default {
  name: 'LoginFormInputPhone',
  components: { LoginFormItemSelectCountry, BaseInput },
  props: {
    countryCallingCode: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  emits: [
    'update:country-calling-code',
    'update:phone-number',
    'blur:phone-number',
  ],
  computed: {
    countryCallingCodeInternal: {
      get() {
        return this.countryCallingCode
      },
      set(val) {
        this.$emit('update:country-calling-code', val)
      },
    },
    hasError() {
      return !!this.errorMessage
    },
  },
  methods: {
    isNumber(evt) {
      evt = evt || window.event

      const charCode = evt.which ? evt.which : evt.keyCode

      if (
        (charCode < 1632 || charCode > 1641) && // To allow arabic numbers
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
  },
}
</script>

<template>
  <div class="tamara-login-form-input-phone">
    <label for="label" class="tamara-login-form-input-phone__label">
      {{ $t('login_phone_number_label') }}
    </label>
    <div
      dir="ltr"
      class="tamara-login-form-input-phone__input"
      :class="{ 'has-error': hasError }"
    >
      <div class="tamara-login-form-input-phone__input__wrapper">
        <div class="tamara-login-form-input-phone__input__select-country">
          <LoginFormItemSelectCountry
            v-model="countryCallingCodeInternal"
            default-first-option
          />
        </div>
        <BaseInput
          id="phone-number"
          name="Phone Number"
          :value="phoneNumber"
          type="tel"
          pattern="[0-9]*"
          inputmode="numeric"
          :placeholder="$t('login_phone_number_placeholder')"
          class="tamara-login-form-input-phone__input__field"
          @keypress.native.stop="isNumber"
          @blur="$emit('blur:phone-number', $event)"
          @input="$emit('update:phone-number', $event)"
          @keyup.enter.native="$emit('enter', $event)"
        />
      </div>
      <div
        v-if="hasError"
        class="tamara-login-form-input-phone__input__error-message"
      >
        <svg-icon
          class="error-message-icon"
          icon-class="warning-circle-lavender"
          height="16px"
          width="16px"
        />
        <span>{{ errorMessage }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/lavender/design.scss';

.tamara-login-form-input-phone {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--tamara-spacing-xs);

  &__label {
    @extend .tamara-label-large;
  }

  &__input {
    display: flex;
    flex-direction: column;
    gap: 10px;
    transition: height 4s linear;

    &.has-error {
      ::v-deep {
        .el-input__inner {
          border-color: var(--tamara-color-error) !important;
          border-width: 2px !important;
        }
      }
    }

    &__wrapper {
      display: flex;
      gap: 10px;
      align-items: center;
    }

    &__select-country {
      flex: 0 0 120px;

      ::v-deep {
        .el-select {
          .el-input__inner {
            @extend .tamara-body-large;

            height: 48px;
            padding: var(--tamara-spacing-sm) var(--tamara-spacing-sm);
            margin: 0;
            color: #212442;
            border: 1px solid var(--tamara-color-functional-grey-light);
            border-radius: var(--tamara-border-radius-md);
            outline: none;
          }
        }
      }
    }

    &__error-message {
      display: flex;
      gap: var(--tamara-spacing-2xs);
      align-items: center;
      color: var(--tamara-color-error);
      transform-origin: top;
      animation: slideDown 0.3s ease-out;

      @extend .tamara-body-small;

      @keyframes slideDown {
        from {
          opacity: 0;
          transform: translateY(-10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .error-message-icon {
        flex: 0 0 16px;
      }

      &.is-static {
        position: static;
      }
    }
  }
}
</style>
